<template lang="html">
  <div class="elevation-1 casesearch">
    <v-row>
      <v-col cols="12" :md="searchTextWidth">
        <v-text-field light clearable class="search" label="Questions" v-model="sq" prepend-inner-icon="search"
        v-on:keyup.enter="doQuery(sq, 'Q')" />
      </v-col>
      <v-col cols="12" :md="(12 - searchTextWidth) / 2">
        <v-text-field clearable class="search" label="Exams" v-model="se" prepend-inner-icon="search"
        v-on:keyup.enter="doQuery(se, 'E')" />
      </v-col>
      <v-col cols="12" :md="(12 - searchTextWidth) / 2">
        <v-text-field clearable class="search" label="Tests" v-model="st" prepend-inner-icon="search"
        v-on:keyup.enter="doQuery(st, 'T')" />
      </v-col>
    </v-row>
    <div class="resultTable" v-if="searchResult.length > 0">
      <v-data-table :headers="searchResultHeaders" :items="searchResult"
      hide-default-header class="elevation-0" @click:row="selectQuery">
        <template v-slot:item.Query="{ item }">
          <td style="font-size: 1em; padding: 5px;">
            {{ item.query }}
          </td>
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      sq: '',
      se: '',
      st: '',
      searchResult: [],
      searchTextWidth: 4,
      pagination: {
        page: 1,
        totalItems: 100
      },
      searchResultHeaders: [
        { text: 'Query', value: 'query' },
        { text: 'Result', value: 'Result' }
      ]
    }
  },
  computed: {
    ...mapGetters({
      caseId: 'getCaseId',
      encounterId: 'getEncounterId',
      search: 'search',
      // showPatientProgress: 'showPatientProgress',
      encounterData: 'getEncounterData'
    })
  },
  watch: {
    // showPatientProgress: 'showProgress',
    searchResult: function (newVal, oldVal) {
      this.pagination.totalItems = newVal.length
    },
    caseId: function () {
      this.searchResult.splice(0, this.searchResult.length)
    },
    encounterId: function () {
      this.searchResult.splice(0, this.searchResult.length)
    }
  },
  methods: {
    doQuery: function (qStr, type) {
      if (qStr === null || qStr === '') return
      this.searchResult = this.encounterData.filter(q => {
        return q.query.toLowerCase().includes(qStr.toLowerCase()) && q.type === type
      })
    },
    showProgress: function () {
      console.log(`[INFO] Showing the patient progress: ${this.caseId} - ${this.encounterId}.`)
      // Display the patient progress information.
      if (this.showPatientProgress) {
        let res = this.$store.getters.search({ qStr: 'patient progress', type: 'ZP' })
        this.searchResult = res
        this.$store.dispatch('selectQuery', res[0])
      } else {
        this.searchResult = []
      }
    },
    selectQuery: function (q) {
      this.$store.dispatch('selectQuery', q)
    }
  }
}
</script>

<style lang="css">
.v-datatable__actions__select {
  /* Don't display the row per page selector. */
  display: none
}
.casesearch {
  padding-top: 20px;
  height: 100%;
  font-size: 1em;
}
.search {
  /* font-size: .9em; */
  margin: 2px;
  /* width: 50%; */
}
.v-label {
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/Case/components/CaseSearch.vue